import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from "../utils/config.service";
import { BaseService } from "./base.service";
import { Observable } from 'rxjs/Observable';
import { Subject } from "rxjs/Rx";
import { AppenateCreateUserModel, AppenateDeleteUserModel } from "../models/appenate-createuser.model";

@Injectable()
export class AppenateService extends BaseService {
  private client = new Subject<any>();
  baseApiUrl: string = '';
  createuserUrl: string = '';
  updateUserUrl: string = '';
  deleteUserAppenateUrl: string='';
  isExistAppenateUserUrl: string='';

  constructor(private http: HttpClient, private configService: ConfigService) {
    super();
    this.baseApiUrl = this.configService.getApiURI();
    this.createuserUrl = this.baseApiUrl + '/Appenate/createuser';
    this.updateUserUrl = this.baseApiUrl + '/Appenate/EditUser';
    this.deleteUserAppenateUrl = this.baseApiUrl + '/Appenate/DeleteUser';
    this.isExistAppenateUserUrl = this.baseApiUrl + '/Appenate/isAppenateUserExist';
  }

  // Create appenate User
  async createuser(userData: AppenateCreateUserModel) {
    return await this.http.post(this.createuserUrl, userData).toPromise();
  }

  async updateUser(userData: AppenateCreateUserModel) {
    return await this.http.post(this.updateUserUrl, userData).toPromise();
  }

  // Create appenate User
  async isExistAppenateUser(CompanyId: number, IntegrationKey:string, Email:string) {
    return await this.http.get(this.isExistAppenateUserUrl + '/' + CompanyId + '/' + IntegrationKey + '/' + Email).toPromise();
  }

  // Delete appenate user
  deleteUser(userDeleteData: AppenateDeleteUserModel){
    return this.http.post(this.deleteUserAppenateUrl, userDeleteData).toPromise();
  }
}
